import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface MessagesContextType {
  unreadCount: number;
  setUnreadCount: (count: number) => void;
  updateUnreadCount: () => void;
  refreshTrigger: number;
}

const MessagesContext = createContext<MessagesContextType | undefined>(undefined);

export function MessagesProvider({ children }: { children: ReactNode }) {
  const [unreadCount, setUnreadCount] = useState(0);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const updateUnreadCount = useCallback(() => {
    // Trigger re-fetch in Dashboard by incrementing the trigger
    setRefreshTrigger((prev) => prev + 1);
  }, []);

  const value: MessagesContextType = {
    unreadCount,
    setUnreadCount,
    updateUnreadCount,
    refreshTrigger,
  };

  return (
    <MessagesContext.Provider value={value}>
      {children}
    </MessagesContext.Provider>
  );
}

export function useMessages() {
  const context = useContext(MessagesContext);
  if (context === undefined) {
    throw new Error('useMessages must be used within a MessagesProvider');
  }
  return context;
}

